export enum CodProducts {
  PorLoQueConduces = "A-KM",
  ParaTuAuto = "A-PA",
  PorSiChocas = "A-PC",
  PorSiPierdesTuAuto = "A-PT",
  ParaTuSeguroDeLey = "A-PL",
  AutoComprensivo = "B-AC",
  AutoEmpresa = "A-PE",
  VidaCredito = "B-VC",
  ParaTuMejorAmigo = "F-MA",
  PorSiTeEnfermas = "S-EN",
  ParaSuBienestar = "F-BD",
  PorSiTeAccidentas = "F-AP",
  PorSiPierdesTusIngresos = "F-IN",
  ParaTuBici = "A-BR",
  EmergenciasDelHogar = "F-EH",
  ParaTusEquipos = "A-EE",
  VidaHipotecario = "B-VH",
  TarjetaDeCredito = "B-TC",
}
